import { render, staticRenderFns } from "./DisplayInvoice.vue?vue&type=template&id=50d5252e&scoped=true&"
import script from "./DisplayInvoice.vue?vue&type=script&lang=js&"
export * from "./DisplayInvoice.vue?vue&type=script&lang=js&"
import style0 from "./DisplayInvoice.vue?vue&type=style&index=0&id=50d5252e&prod&scoped=true&lang=css&"
import style1 from "./DisplayInvoice.vue?vue&type=style&index=1&id=50d5252e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50d5252e",
  null
  
)

export default component.exports